import script from "./ModalAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalAlert.vue?vue&type=script&setup=true&lang=js"

import "./ModalAlert.vue?vue&type=style&index=0&id=709fcaa5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-709fcaa5"]])

export default __exports__